export default "__VITE_ASSET__CmQAjbr2__"